import classNames from 'classnames';
import React from 'react';
import { BsExclamationCircle } from 'react-icons/bs';

import MIcon from 'views/MIcon/MIcon';
import MTooltip from 'views/MTooltip/MTooltip';

import classes from './MInput.module.scss';

type Props = {
  innerRef?: React.RefObject<HTMLInputElement>;
  name?: string;
  invalid?: boolean;
  disabled?: boolean;
  value?: string | number;
  type?: string;
  className?: string;
  min?: string;
  max?: string;
  step?: string;
  placeholder?: string;
  autoComplete: string;
  autoFocus?: boolean;
  autoSelectOnFocus?: boolean;
  defaultValue?: string;
  pattern?: string;
  required?: boolean;
  startIcon?: JSX.Element | null;
  endIcon?: JSX.Element | null;
  inputClassName?: string;
  bottomBorder?: boolean;
  ignoreInvalidIcon?: boolean;
  tabIndex?: number;
  validationErrorText?: string | null;
  onInput?: (event: React.ChangeEvent<HTMLInputElement>) => string;
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onPaste?: (value: React.ClipboardEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

const MInputView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const _onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    if (props.autoSelectOnFocus) {
      event.target.select();
    }

    props.onFocus?.();
  };

  return (
    <div
      className={`${classes['container']} ${props.bottomBorder ? classes['container--bottomBorder'] : ''} ${
        props.invalid ? classes['container--invalid'] : ''
      } ${props.className || ''}`.trim()}
    >
      {props.startIcon}
      <input
        ref={props.innerRef}
        name={props.name}
        disabled={props.disabled}
        value={props.value}
        type={props.type}
        className={classNames(classes['container__field'], props.inputClassName)}
        min={props.min}
        max={props.max}
        step={props.step}
        placeholder={props.placeholder}
        autoComplete={props.autoComplete}
        defaultValue={props.defaultValue}
        pattern={props.pattern}
        required={props.required}
        onInput={props.onInput}
        onFocus={(e) => _onFocus(e)}
        autoFocus={props.autoFocus}
        onPaste={props.onPaste}
        onBlur={props.onBlur}
        onChange={props.onChange}
        onClick={props.onClick}
        onKeyDown={props.onKeyDown}
        {...(props.tabIndex && { tabIndex: props.tabIndex })}
      />
      {props.endIcon}
      {props.invalid && !props.ignoreInvalidIcon ? (
        <MTooltip text={props.validationErrorText || ''}>
          <MIcon className={classes['invalid']} name={BsExclamationCircle} />
        </MTooltip>
      ) : null}
    </div>
  );
};

MInputView.displayName = 'MInputView';
MInputView.defaultProps = {};

export default MInputView;
